import { __module as t } from "./ghl-ui.es1679.js";
import { i as f } from "./ghl-ui.es1541.js";
import { a as p } from "./ghl-ui.es1680.js";
import { r as m } from "./ghl-ui.es1637.js";
import { t as x } from "./ghl-ui.es1636.js";
(function(o, e) {
  var r = f.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  var s = r(p), a = r(m), i = r(x);
  function u(d, l) {
    (0, a.default)(2, arguments);
    var n = (0, i.default)(l);
    return (0, s.default)(d, -n);
  }
  o.exports = e.default;
})(t, t.exports);
var b = t.exports;
export {
  b as s
};
